// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"491bd2c7","320":"af680d1f","328":"8e78bd03","496":"e889aa29","679":"c8cc5955"}[chunkId] + ".chunk.css";
};